import { ReactNode, useEffect } from 'react';

import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';

import {
    getQueryParameter,
    getWindowLocation
} from '../iwRouter/LocationHelper';
import ImpersonationBar from './impersonationBar/ImpersonationBar';
import {
    RETRIEVE_SITE_CONTEXT,
    SKIP_SITE_CONTEXT_API
} from './IwSiteContext.actions';
import {
    SITE_CONTEXT_CACHE_KEY,
    storeResponseInReactQuery
} from '../iwQueryClient/iwQueryClient';

const mapStateToProps = ({ siteContext }: RootState) => ({
    ready: siteContext.ready
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
    retrieveSiteContext: (impersonatingStateKey?: string) =>
        dispatch({ type: RETRIEVE_SITE_CONTEXT, impersonatingStateKey }),
    saveSiteContext: (site_context: object) =>
        dispatch({ type: SKIP_SITE_CONTEXT_API, site_context })
});

type PropsFromRedux = ReturnType<typeof mapStateToProps> &
    ReturnType<typeof mapDispatchToProps>;

function IwSiteContext({
    ready,
    children,
    siteContext,
    retrieveSiteContext,
    saveSiteContext
}: {
    children: ReactNode;
    siteContext?: RootState['siteContext'];
} & PropsFromRedux) {
    useEffect(() => {
        if (_.isObject(siteContext)) {
            // This for test cases when trying to inject site_context
            // without going through the API layer
            // -> Runs only on tests -> TERRIBLE IDEA -> 0/10 "Wouldn't play again"
            storeResponseInReactQuery({
                cacheKey: [SITE_CONTEXT_CACHE_KEY],
                response: siteContext
            });
            saveSiteContext(siteContext);
        } else {
            const currentLocation = getWindowLocation();
            const impersonatingStateKey = getQueryParameter(
                currentLocation,
                'state_key'
            );
            retrieveSiteContext(impersonatingStateKey);
        }
    }, [siteContext, saveSiteContext, retrieveSiteContext]);

    return (
        <div>
            <ImpersonationBar />
            {ready && children}
        </div>
    );
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps, mapDispatchToProps)(IwSiteContext);
